import React,{useContext} from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import { LanguageContext } from '../context/LanguageContext';
import animationData1 from '../lotties/lottie_trophy.json';
import animationData2 from '../lotties/lottie_trophy.json';
import animationData3 from '../lotties/lottie_trophy.json';
import headerImage1 from '../images/header_nou_2.png'
import headerImage2 from '../images/header_nou_2.png'
import headerImage3 from '../images/header_nou_2.png'



const CustomSlider = () => {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2200,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false
  };


  const slidesData = [
    {
      title: t('txt.totalPredictionsTitle'),
      subtitle: t('txt.totalPredictionsDescription'),
      cta: t('btn.totalPredictions'),
      headerImg: headerImage1,
      lottie: animationData1,
      page: "/predictions"
    },
    {
      title: t('txt.faqTitle'),
      subtitle: t('txt.faqDescription'),
      cta: t('btn.faq'),
      headerImg: headerImage2,
      lottie: animationData2,
      page: "/faq"
    },
    {
      title: t('txt.strategyTitle'),
      subtitle: t('txt.strategyDescriptions'),
      cta: t('btn.strategy'),
      headerImg: headerImage3,
      lottie: animationData3,
      page: "/strategii"
    },
  ];

  return (
    <div className="w-full max-w-[95vw] md:max-w-[800px] mx-auto my-4">
    <Slider {...settings}>
  {slidesData.map((slide, index) => (
    <div key={index} className="px-2">
      <div 
        onClick={() => navigate(slide.page)}
        className="bg-[#2c3e50] rounded-[10px] overflow-hidden cursor-pointer relative flex flex-col min-h-[200px]"
      >
        {/* Top section with image (full width) */}
        <div className="w-full h-[60px] mb-3">
          <div className="w-full h-full overflow-hidden rounded-md">
            <img 
              src={slide.headerImg} 
              alt="Header" 
              className="w-full h-full object-fil"
            />
          </div>
        </div>

        {/* Bottom section with two columns */}
        <div className="flex flex-row p-4 pt-0">
          {/* Left column with text */}
          <div className="flex-1 flex flex-col pr-4">
            <h2 className="text-[#f39c12] text-lg font-bold mb-2">{slide.title}</h2>
            <p className="text-white text-sm mb-2">{slide.subtitle}</p>
            <span className="text-white text-sm underline">{slide.cta}</span>
          </div>
          
          {/* Right column with Lottie */}
          <div className="flex-shrink-0 flex items-center justify-center">
            <Lottie 
              animationData={slide.lottie} 
              style={{ width: 80, height: 80 }}
            />
          </div>
        </div>
      </div>
    </div>
  ))}
</Slider>
    </div>
  );
};

export default CustomSlider;
